import styled from 'styled-components';

export const ContainerChangeLog = styled.div`
  width: 100%;
  height: 100%;
  background-color: #ffffff;
  box-sizing: border-box;

  .filters {
    display: flex;
    padding: 10px;
    gap: 10px;
    margin-bottom: 10px;
    border-bottom: 1px solid #eee;

    .filter-btn {
      padding: 6px 16px;
      border-radius: 20px;
      border: 1px solid #e0e0e0;
      background: #fff;
      color: #666;
      font-size: 14px;
      cursor: pointer;
      transition: all 0.2s;

      &.active {
        background: #10b981;
        color: #fff;
        border-color: #10b981;
      }

      &:hover:not(.active) {
        border-color: #10b981;
        color: #10b981;
      }
    }
  }

  .timeline-container {
    display: flex;
    height: calc(100vh - 215px);
    flex-direction: column;
    overflow-y: auto;
    padding: 10px;
  }

  .timeline-item {
    width: 100%;
    display: flex;
    position: relative;
    padding-bottom: 10px;

    &:last-child .line {
      display: none;
    }

    .left-column {
      display: flex;
      flex-direction: column;
      align-items: center;
      margin-right: 5px;
      position: relative;
      z-index: 1;

      .version-badge {
        padding: 12px;
        border-radius: 20px;
        font-size: 13px;
        font-weight: 600;
        color: #fff;
        z-index: 2;
      }

      .line {
        position: absolute;
        top: 25px;
        bottom: -25px;
        left: 50%;
        transform: translateX(-50%);
        width: 2px;
        background-color: #eaeaea;
        z-index: 0;
      }
    }

    .right-column {
      flex: 1;
      padding: 10px;
      background: #fff;
      border: 1px solid transparent;
      border-radius: 10px;
      cursor: pointer;
      transition: all 0.3s ease;
      
      &:hover {
        transform: translateY(-2px);
        box-shadow: 0 4px 15px rgba(0,0,0,0.05);
        border-color: #eaeaea;
      }
      .item-header {
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
        margin-bottom: 8px;

        h3 {
          font-size: 18px;
          font-weight: 700;
          color: #222;
          margin: 0;
        }

        .date {
          font-size: 13px;
          color: #999;
          white-space: nowrap;
        }
      }

      .tags {
        display: flex;
        gap: 8px;
        margin-bottom: 15px;

        .tag {
          padding: 4px 10px;
          border-radius: 8px;
          font-size: 11px;
          font-weight: 700;
          letter-spacing: 0.5px;
        }
      }

      .description {
        font-size: 15px;
        color: #555;
        line-height: 1.5;
        margin-bottom: 15px;
        white-space: pre-wrap;
      }

      .expanded-wrapper {
        display: grid;
        grid-template-rows: 0fr;
        transition: grid-template-rows 0.3s ease-in-out;
        
        &.open {
          grid-template-rows: 1fr;
        }
        
        .expanded-content {
          overflow: hidden;
          
          .inner-content {
            padding-top: 15px;
            margin-bottom: 15px;
            border-top: 1px solid #f0f0f0;

            .sub-log-item {
                margin-top: 8px;
                font-size: 14px;
                color: #555;
            }

            .admin-actions {
              display: flex;
              gap: 10px;
              margin-top: 20px;
              
              button {
                padding: 6px 12px;
                border-radius: 6px;
                border: none;
                cursor: pointer;
                font-size: 13px;
                font-weight: 500;
                transition: background 0.2s;
              }

              .btn-edit {
                background: #e8f0fe;
                color: #1a73e8;
                &:hover { background: #d2e3fc; }
              }

              .btn-delete {
                background: #fce8e6;
                color: #d93025;
                &:hover { background: #fad2cf; }
              }
            }
          }
        }
      }

      .author {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 8px;
        font-size: 13px;
        color: #777;

        svg {
          color: #bbb;
        }

        span {
            display: flex;
            align-items: center;
            gap: 4px;
            color: #b4b4b4ff;
            font-weight: 500;
        }

        strong {
          color: #444;
          font-weight: 600;
          margin: 0px;
          padding: 0px;
        }
      }
    }
  }

  .actions {
    display: flex;
    justify-content: flex-end;
    margin-bottom: 50px;

    .add-btn {
      width: 50px;
      height: 50px;
      border-radius: 50%;
      background: #10b981;
      color: #fff;
      border: none;
      font-size: 24px;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      box-shadow: 0 4px 10px rgba(16, 185, 129, 0.3);
      transition: transform 0.2s, box-shadow 0.2s;

      &:hover {
        transform: scale(1.05);
        box-shadow: 0 6px 15px rgba(16, 185, 129, 0.4);
      }
    }
  }

  .pagination-container {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 10px;
    border-top: 1px solid #d9d9d9;
  }
`;
